import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles(() => ({
  contentContainer: {
    '@media (max-width: 768px)': {
      paddingTop: '85px',
    },
  },
  // Mirrors the subtitle style of the shared Wizard ContentHeader. The subtitle is rendered
  // here instead of through ContentHeader because it interpolates the destination in bold,
  // and ContentHeader only accepts a plain string.
  subtitle: {
    fontSize: '16px',
    lineHeight: '24px',
    color: STYLE.COLOR.TEXT2,
    fontWeight: 400,
    margin: '4px 0 0 0',
    '@media (max-width: 600px)': {
      fontSize: '14px',
      lineHeight: '24px',
    },
  },
  destination: {
    color: STYLE.COLOR.TEXT1,
  },
  otpParent: {
    marginTop: '32px',
    '@media (max-width: 768px)': {
      marginTop: '24px',
    },
  },
  otpInputs: {
    '@media (max-width: 480px)': {
      gap: '8px !important',
    },
  },
  buttonParent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '32px',
    gap: '12px',
    '@media (max-width: 768px)': {
      justifyContent: 'center',
      marginTop: '24px',
      flexDirection: 'column-reverse',
    },
  },
  button: {
    minWidth: '180px !important',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
}));
